import { observer } from 'mobx-react-lite'
import React from 'react'
import Switch from '../../../../FormComponents/Switch'
import Contact from '../../../../Advertiser/CampaignShare/CampaignPageParts/ReportParts/Contact'
export default observer(function ContactUs({ values, setFieldValue, campaign }) {

  return (
    <div className="bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-2xl p-4 mt-4">
      <div className="flex justify-between items-center">
        <p className="font-bold text-xl dark:text-white">Contact Us</p>
        <Switch name="contact_us_visible" value={values.contact_us_visible} onChange={({ target: { checked }}) => setFieldValue('contact_us_visible', checked, true)} eyeSwitch />
      </div>
      {values.contact_us_visible && (
        <div className='mt-4'>
          <Contact campaign={campaign} pmSide />
        </div>
      )}
    </div>
  )
})